import { createFileRoute } from "@tanstack/react-router";
import { Input } from "@ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@ui/table";
import { useState } from "react";
import { enzymes } from "restriction-enzymes";

export const Route = createFileRoute("/reference/enzymes")({
  component: EnzymesComponent,
});

function EnzymesComponent() {
  const [search, setSearch] = useState("");

  const filtered = enzymes.filter(
    (enzyme) =>
      enzyme.name.toLowerCase().includes(search.toLowerCase()) ||
      enzyme.site.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="p-4">
      <div className="mb-4 max-w-sm">
        <Input
          placeholder="Search enzymes..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <Table className="table-fixed">
        <TableHeader>
          <TableRow>
            <TableHead className="w-32">Name</TableHead>
            <TableHead className="w-48">Recognition Site</TableHead>
            <TableHead className="w-24">Overhang</TableHead>
            <TableHead className="w-16">NEB</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {filtered.map((enzyme) => (
            <TableRow key={enzyme.name}>
              <TableCell className="font-medium">{enzyme.name}</TableCell>
              <TableCell className="font-mono">{enzyme.site}</TableCell>
              <TableCell>{enzyme.overhangType}</TableCell>
              <TableCell>
                {enzyme.suppliers.includes("N") && (
                  <a
                    href={`https://www.neb.com/en-us/search#q=${enzyme.name}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    View
                  </a>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
